import { render, staticRenderFns } from "./oupons.vue?vue&type=template&id=1fd9d32c&scoped=true&"
import script from "./oupons.vue?vue&type=script&lang=js&"
export * from "./oupons.vue?vue&type=script&lang=js&"
import style0 from "./oupons.vue?vue&type=style&index=0&id=1fd9d32c&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd9d32c",
  null
  
)

export default component.exports